<template>
  <CountryPage country="new_zealand" />
</template>